import Config from 'conf';
import Logger from 'data/common/Logger';
import EventEmitter from './EventEmitter';

/*const { session } = require('electron');
const ses = session.fromPartition('persist:name');*/

const FormData = require('form-data');
const UAParser = require('ua-parser-js');

const parser = new UAParser().getResult();
let eventEmitter = null;
let apis = {};

const timeout = function timeout(ms, promise) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(new Error('error.api.timeout'));
        }, ms);
        promise.then(resolve, reject);
    });
};

function makeFetchUrlWithGetParams(fetchUrl, key, param) {
    if (fetchUrl.indexOf('?') > -1) {
        fetchUrl = `${fetchUrl}&${key}=${param}`;
    } else {
        fetchUrl = `${fetchUrl}?${key}=${param}`;
    }
    return fetchUrl;
}

function ApiCall() {
    this.api_url = Config.url_api;
    this.access_token = null;
    this.private_token = null;
    this.uniqueDeviceId = `${parser.os.name}_${parser.os.version}_${parser.browser.name}_${parser.browser.version}`;
}

function slugify(text) {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '_') // Replace spaces with -
        .replace(/[^\w_]+/g, '') // Remove all non_word chars
        .replace(/__+/g, '_') // Replace multiple _ with single _
        .replace(/^_+/, '') // Trim - from start of text
        .replace(/_+$/, ''); // Trim - from end of text
}

ApiCall.prototype.call = function call(urlParam) {
    const self = this;

    return new Promise((resolve, reject) => {
        const resultAccessToken = localStorage.getItem('access_token');

        if (resultAccessToken) self.access_token = resultAccessToken.replace(/"/g, '');

        const fetchData = { method: urlParam.method };
        let fetchUrl = self.api_url + urlParam.url;

        const headers = {
            Accept: 'application/json, application/xml, text/play, text/html, *.*',
        };

        if (urlParam.url === 'https://apiv2.solidom.net/fheconnect/v1.1/initialize') {
            fetchUrl = urlParam.url;
            headers.Authorization = `Access-Token ${urlParam.route_params.token}`;
        }

        if (typeof urlParam.override_url !== 'undefined' && urlParam.override_url) {
            fetchUrl = urlParam.override_url;
        }

        if (self.private_token) headers['Private-Token'] = self.private_token;
        else if (!headers.Authorization && self.access_token) {
            headers.Authorization = `Bearer ${self.access_token}`;
        }

        if (self.uniqueDeviceId) {
            headers['Device-ID'] = self.uniqueDeviceId;
        }
        if (typeof urlParam.route_params !== 'undefined') {
            Object.keys(urlParam.route_params).forEach(param => {
                const re = new RegExp(`:${param}`, 'g');
                fetchUrl = fetchUrl.replace(re, urlParam.route_params[param]);
            });
        }

        if (typeof urlParam.post_params !== 'undefined') {
            Logger.debug('post_params', urlParam.post_params);
            const form = new FormData();
            Object.keys(urlParam.post_params).forEach(param => {
                if (Array.isArray(urlParam.post_params[param])) {
                    for (let i = 0; i < urlParam.post_params[param].length; i++) {
                        form.append(`${param}[]`, urlParam.post_params[param][i]);
                    }
                } else form.append(param, urlParam.post_params[param]);
            });
            fetchData.body = form;
        }

        if (typeof urlParam.body_params !== 'undefined') {
            fetchData.body = JSON.stringify(urlParam.body_params);
            headers['Content-Type'] = 'application/json';
        }
        if (typeof urlParam.patch_params !== 'undefined') {
            fetchData.body = JSON.stringify(urlParam.patch_params);
            headers['Content-Type'] = 'application/json';
        }
        if (typeof urlParam.put_params !== 'undefined') {
            fetchData.body = JSON.stringify(urlParam.put_params);
            headers['Content-Type'] = 'application/json';
        }

        if (typeof urlParam.get_params !== 'undefined') {
            Object.keys(urlParam.get_params).forEach(param => {
                if (Array.isArray(urlParam.get_params[param])) {
                    urlParam.get_params[param].forEach(element => {
                        fetchUrl = makeFetchUrlWithGetParams(fetchUrl, param, element);
                    });
                } else {
                    fetchUrl = makeFetchUrlWithGetParams(fetchUrl, param, urlParam.get_params[param]);
                }
            });
        }

        try {
            fetchData.headers = headers;
            Logger.log('Call API URL', fetchUrl);
            Logger.log('Call API DATA', fetchData);
            return timeout(Config.timeout_api, fetch(fetchUrl, fetchData))
                .then(response => {
                    return response.text().then(responseText => {
                        let responseData = responseText;
                        try {
                            responseData = JSON.parse(responseText);
                        } catch (e) {
                            Logger.log('Error parsing response', responseText);
                            throw e;
                        }
                        Logger.debug('Call API Resolve', {
                            response,
                            data: responseData,
                        });
                        if (response.status === 200 || response.status === 201) {
                            if (typeof responseData === 'object' && responseData.message) {
                                responseData.message = `api.message.${slugify(responseData.message)}`;
                            }
                            return resolve({
                                response,
                                data: responseData,
                            });
                        }

                        if (typeof responseData === 'object' && responseData.errors && responseData.errors[0].message) {
                            responseData.errors[0].message = `api.message.${slugify(responseData.errors[0].message)}`;
                        }
                        setTimeout(() => {
                            eventEmitter.emit(`error${response.status}`, responseData);
                        });
                        return reject(responseData, response);
                    });
                })
                .catch(error => {
                    Logger.error('Error retour API', error);
                    Logger.error('Error retour API', error.message);
                    if (error.message === 'Failed to fetch') {
                        return reject(new Error('FAILED_TO_FETCH'));
                    } else if (error.message === 'error.api.timeout') {
                        eventEmitter.emit('api_timeout', {
                            message: error.message,
                        });
                    } else {
                        Logger.log('Erreur API', error.message);
                    }
                    return reject(error);
                });
        } catch (error) {
            Logger.error('Error fetch API', error);
            return reject(error);
        }
    });
};

ApiCall.prototype.providerAuthentification = function providerAuthentification(providerAuthCode, providerType, srcType) {
    const self = this;
    const obj = {
        url: '/auth-provider',
        method: 'POST',
        post_params: { providerAuthCode, providerType, srcType },
    };
    return self
        .call(obj)
        .then(result => {
            localStorage.setItem('access_token', result.data.access_token);
            self.access_token = result.data.access_token;
            return result;
        })
        .catch(e => {
            throw e;
        });
};

ApiCall.prototype.logout = function logout(successCallback, errorCallback) {
    const obj = {
        url: '/logout',
        method: 'GET',
        successCallback,
        errorCallback,
    };
    this.call(obj);
};

ApiCall.prototype.destroy = function destroy() {
    localStorage.removeItem('access_token');
};

export default (api = 'fhe') => {
    if (!apis[api]) {
        Logger.debug("Instanciation de l'API", api);
        apis[api] = new ApiCall(api);
        eventEmitter = new EventEmitter();
    }
    return apis[api];
};



// WEBPACK FOOTER //
// ./data/common/ApiCallGenerique.js